import { render, staticRenderFns } from "./BrokerAccountsInput.vue?vue&type=template&id=4704bc8d&scoped=true&"
import script from "./BrokerAccountsInput.vue?vue&type=script&lang=js&"
export * from "./BrokerAccountsInput.vue?vue&type=script&lang=js&"
import style0 from "./BrokerAccountsInput.vue?vue&type=style&index=0&id=4704bc8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704bc8d",
  null
  
)

export default component.exports